'use client';

import { AtClickable } from '@/components/atoms';
import {
  EClickableVariants,
  EClickableTarget,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { getRegionUrlById } from './utils/locationMapper';
import { useLocation } from '@/context/locationContext';
import { IMlcopyBlockCSProps } from '@/lib/contentstack-sdk/types';

export const TmHomePlanDetailWhatsIncludedCta = ({
  leftContent,
}: {
  leftContent: IMlcopyBlockCSProps | undefined;
}) => {
  const { currentBuildStudio } = useLocation();

  return (
    <AtClickable
      href={getRegionUrlById(Number(currentBuildStudio?.Id))}
      variant={
        leftContent?.link?.variant
          ? EClickableVariants[leftContent?.link?.variant]
          : EClickableVariants.PRIMARY
      }
      outline={leftContent?.link?.outline ?? true}
      label={leftContent?.link?.url?.title || 'See All Included Features'}
      interactLocation="Included Features"
      target={EClickableTarget.BLANK}
    />
  );
};
